import { render, staticRenderFns } from "./OrdersFilter.vue?vue&type=template&id=44fb2d94&"
import script from "./OrdersFilter.vue?vue&type=script&lang=js&"
export * from "./OrdersFilter.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports